<template>
  <Drawer
    v-model:open="isDrawerOpen"
    :vaul-drawer-wrapper="false"
    @update:open="(e) => onclose(e)"
  >
    <DrawerContent
      class="rounded-t-3xl sm:rounded-t-xl !bg-[linear-gradient(0deg,#f7f9fb_77.19%,#e1f0ff_100%)]"
    >
      <div class="max-w-5xl mx-auto flex flex-col items-center w-full px-6">
        <div class="flex justify-between items-center w-full">
          <h2 class="text-[#101828] text-lg font-bold">Filter</h2>
          <Icon
            height="24"
            icon="ri:arrow-down-s-line"
            class="text-text-secondary"
            @click="handleClose"
          />
        </div>
        <div class="mt-6 w-full flex">
          <div class="flex flex-col gap-y-1 border-r w-max">
            <div
              v-for="(item, category) in filters"
              :key="category"
              class="pr-6"
            >
              <div
                class="flex items-center"
                @click="selectedFilterType = String(category)"
              >
                <div
                  class="w-1 h-4 bg-primary rounded-lg"
                  :class="{
                    invisible: String(category) !== selectedFilterType,
                  }"
                ></div>
                <div
                  class="py-2 pl-3 pr-9 capitalize text-text-content text-sm font-medium"
                >
                  {{ $t(String(category), category) }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="overflow-y-auto h-full grow w-max pl-6 flex flex-col gap-y-1"
          >
            <div
              v-for="(subcategory, index) in filters[selectedFilterType]"
              :key="index"
            >
              <div
                class="flex items-center rounded-lg border-transparent border"
                :class="{
                  'bg-white !border-border-primary':
                    String(subcategory) === selectedFilter,
                }"
                @click="selectedFilter = String(subcategory)"
              >
                <div
                  class="py-2 px-3 capitalize text-text-content text-sm font-medium"
                >
                  {{ $t(String(subcategory), subcategory) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="py-2 w-full">
          <Button class="w-full" @click="handleClick">Done</Button>
        </div>
      </div>
    </DrawerContent>
  </Drawer>
</template>

<script setup>
import { ref, watch } from "vue";
import { Drawer, DrawerContent } from "@/components/ui/drawer";
import Button from "@/components/ui/button/Button.vue";
import { openFilterDrawer } from "@/lib/utils.js";
import { useSubscription } from "@vueuse/rxjs";
import { Icon } from "@iconify/vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

const filters = {
  "sort by": ["new", "random"],
  type: ["free", "pro", "bundle"],
};

const isDrawerOpen = ref(false);
const selectedFilterType = ref("sort by");
const selectedFilter = ref("");

useSubscription(
  openFilterDrawer.subscribe(() => {
    isDrawerOpen.value = true;
  }),
);

watch(
  () => selectedFilterType.value,
  (newVal) => {
    if (newVal == "sort by") {
      selectedFilter.value = route?.query?.sort || "new";
    } else {
      selectedFilter.value = route?.query?.filter || "";
    }
  },
  { immediate: true },
);

const onclose = (state) => {
  if (!state) {
    isDrawerOpen.value = false;
    document.body.style.background = "";
  }
};

const handleClick = () => {
  let currentQuery = { ...route.query };
  if (selectedFilter.value == "random") {
    currentQuery.sort = "random";
    delete currentQuery.page;
    router.replace({ query: { ...currentQuery } });
  } else if (selectedFilter.value == "new") {
    currentQuery.sort = "new";
    delete currentQuery.page;
    router.replace({ query: { ...currentQuery } });
  } else if (selectedFilter.value == "free") {
    currentQuery.filter = "free";
    delete currentQuery.page;
    router.replace({ query: { ...currentQuery } });
  } else if (selectedFilter.value == "pro") {
    currentQuery.filter = "pro";
    delete currentQuery.page;
    router.replace({ query: { ...currentQuery } });
  } else if (selectedFilter.value == "bundle") {
    currentQuery.filter = "bundle";
    delete currentQuery.page;
    router.replace({ query: { ...currentQuery } });
  } else {
    currentQuery.sort = "new";
    delete currentQuery.page;
    router.replace({ query: { ...currentQuery } });
  }
  isDrawerOpen.value = false;
};

const handleClose = () => {
  isDrawerOpen.value = false;
  document.body.style.background = "";
};
</script>
